export const CTL_ADD_TO_CART = "CTL_ADD_TO_CART";
export const CTL_REMOVE_FROM_CART = "CTL_REMOVE_FROM_CART";
export const CTL_SHOW_CART = "CTL_SHOW_CART";
export const CTL_NEW_ROOM = "CTL_NEW_ROOM";
export const CTL_ROOM_TO_PROJECT = "CTL_ROOM_TO_PROJECT";
export const CTL_NEW_PROJECT = "CTL_NEW_PROJECT";
export const CTL_DOWNLOAD = "CTL_DOWNLOAD";
export const CTL_SELECTED_TO_PROJECT = "CTL_SELECTED_TO_PROJECT";
export const CTL_PROJECT_DISTRIBUTE = "CTL_PROJECT_DISTRIBUTE";
export const CTL_PROJECT_TO_ROOM = "CTL_PROJECT_TO_ROOM";
export const CTL_DUBLICATE_ROOM = "CTL_DUBLICATE_ROOM";
export const CTL_SHOW_OWN_ROOMS = "CTL_SHOW_OWN_ROOMS";
export const CTL_SEND_ROOM = "CTL_SEND_ROOM";

